export default __webpack_public_path__ + "static/media/bookshelf.d95d2035.svg";